fx.ns("models", class InstagramPhotoModel extends fx.Model {

	constructor(data)
	{
		super(data);
    }

    get defaults()
    {
        return {
            selected: false
        }
    }

    select()
    {
        this.selected = !this.selected;
    }
});